import { ProductionClass } from '../production.class';
import * as Constants from '../../globals/constants';
import { ResourceService } from '../../services/resource.service';
import { PopulationService } from '../../services/population.service';
import { TechnologyService } from '../../services/technology.service';

/**
 * @internal
 * The isolateExtension allows the user to isolate current selection in the viewer.
 */
export class Datacenter extends ProductionClass {

  /**
   * @ignore
   */
  constructor(resourceHandler: ResourceService, populationService: PopulationService, technologyService: TechnologyService) {
    super(resourceHandler, populationService, technologyService);
    this.initBuilding('Datacenter', 'datacenter', Constants.SETTINGS.BUILDING_SETTINGS.DATA_CENTER);
  }

  // public produce(timePassed) {
  //   super.produce(timePassed);
  //   console.log(this.produced.data)
  // }

  public setResearchBonus() {
    const additiveMultiplier = [];
    const multiplicativeMultiplier = [];

    if (this.technologyService.state.colonial_age) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.industrial_age) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.progressive_era) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.contemporary_era) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.tomorrow) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.deep_space_age) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }
    if (this.technologyService.state.dimensional_era) {
      additiveMultiplier.push(Constants.AGE_BONUS);
    }

    // ----

    if (this.technologyService.state.quantum_computers) {
      multiplicativeMultiplier.push(1); // double speed
    }

    if (this.technologyService.state.warp_drive) {
      multiplicativeMultiplier.push(.10); // +25%
    }

    if (this.technologyService.state.quantum_network) {
      multiplicativeMultiplier.push(.25); // +25%
    }

    if (this.technologyService.state.dimensional_science) {
      multiplicativeMultiplier.push(.25); // +25%
    }


    const amResult = additiveMultiplier.reduce((a, b) => a + b, 1);
    const mmResult = multiplicativeMultiplier.reduce((a, b) => a * (1 + b), 1);

    this.reseachMultiplier = 1 * amResult * mmResult;

    if (!this.technologyService.state.internet) {
      this.reseachMultiplier = 0;
    }
  }

  public unlock() {
    return this.technologyService.state.cloud;
  }

}
